var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98 22.09C1.32 22.09 0.75 21.66 0.55 21.04C0.18 19.85 0 18.65 0 17.25C0 10.13 5.77 4.32999 12.89 4.29999V1.49999C12.89 0.909993 13.24 0.379993 13.77 0.129993C14.31 -0.110007 14.94 -0.020007 15.38 0.369993L23.49 7.52999C23.8 7.79999 23.98 8.18999 24 8.60999C24.01 9.01999 23.85 9.41999 23.56 9.71999L15.45 17.83C15.02 18.26 14.38 18.39 13.82 18.16C13.26 17.93 12.89 17.38 12.89 16.77V13.97C8.67 14 4.69 16.96 3.41 21.03C3.21 21.66 2.63 22.08 1.98 22.08V22.09Z",
    fill: "#0F0F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFilled);
export default __webpack_public_path__ + "static/media/ShareFilled.26d6c6a4.svg";
export { ForwardRef as ReactComponent };